import API from "../../../common/utils/API";
import {closeAddEditModal} from "../../../veritas/add-edit/actions/AddEditActions";
import MARVEL from "../../../common/utils/MarvelUrls";
import { setRouterLink } from "../../../router/RouterActions";
import {updatedDPSourceRefresh} from "../../../veritas/add-edit/actions/AddEditDPSourceActions";
import {activityLoggerActionTypes} from "../constants/UtilityMiddlewareConstants";
import {apiActionsDPSource} from "../constants/ApiMiddlewareConstants";
import {fetchSourceDetailSuccess, toggleSourceDeleteWarning} from "../../../veritas/data-sources/actions/SourceActions";
import {displayDuplicateMessage, displayErrorMessage} from "../../../common/marvel-reducers/formMessageActions";
import {toUpperCaseSentence} from "../../../common/utils/ToUpperCaseSentence";
import INPUT_FIELDS from "../../../common/resources/inputfields.json"

/**
 * This is the Middleware to handle the API calls pertaining to
 * Data Sources. (Currently, only contains logic for post
 * and put... rest will be added subsequently.)
 * @returns Makes the API call and conditionally dispatches logger actions or
 * error or warning messages.
 * @param store
 */
const apiMiddlewareDPSources = (store) => (next) => (action) => {

    switch (action.type) {

        case apiActionsDPSource.POST: {
            next(action);
            const { sourceObject, authToken } = action.payload;

            API.postDPSource(sourceObject, authToken.idToken)
                .then(res => {
                    const log = {
                        object_id: res.data.source_id,
                        object_type: "kyc_dp_source_create",
                        user: authToken.account.name
                    }
                    store.dispatch({
                        type: activityLoggerActionTypes.LOG_CHANGE,
                        payload: {log, authToken}
                    });
                    store.dispatch(closeAddEditModal("DP Source"));
                    store.dispatch(setRouterLink(MARVEL.VERITAS.data_sources + "kyc/" + res.data.source_id))
                })
                .catch(error => {
                    const errorObject = error.response.data
                    const message = [];
                    // Only handle custom error of duplicate identifier number.
                    if (errorObject.message) {
                        const messageList = errorObject.message.split(".")
                        messageList.forEach(m => message.push(m));
                        message.pop()
                        store.dispatch(displayDuplicateMessage(message, true));
                    } else {
                    // pretty print the error message for the user
                    // eslint-disable-next-line no-unused-vars
                    for (let [key, value] of Object.entries(errorObject)) {
                        message.push(toUpperCaseSentence(value[0]));
                    }
                    store.dispatch(displayErrorMessage(message, true));
                    }
                });
            break;
        }

        case apiActionsDPSource.POST_KYB: {
            next(action);
            const { sourceObject, authToken } = action.payload;

            API.postKYBDPSource(sourceObject, authToken.idToken)
                .then(res => {
                    const log = {
                        object_id: res.data.source_id,
                        object_type: "kyb_dp_source_create",
                        user: authToken.account.name
                    }
                    store.dispatch({
                        type: activityLoggerActionTypes.LOG_CHANGE,
                        payload: {log, authToken}
                    });
                    store.dispatch(closeAddEditModal("DP Source"));
                    store.dispatch(setRouterLink(MARVEL.VERITAS.data_sources + "kyb/" + res.data.source_id))
                })
                .catch(error => {
                    const errorObject = error.response.data
                    const message = [];
                    // Only handle custom error of duplicate identifier number.
                    if (errorObject.message) {
                        const messageList = errorObject.message.split(".")
                        messageList.forEach(m => message.push(m));
                        message.pop()
                        store.dispatch(displayDuplicateMessage(message, true));
                    } else {
                    // pretty print the error message for the user
                    // eslint-disable-next-line no-unused-vars
                    for (let [key, value] of Object.entries(errorObject)) {
                        message.push(toUpperCaseSentence(value[0]));
                    }
                    store.dispatch(displayErrorMessage(message, true));
                    }
                });
            break;
        }

        case apiActionsDPSource.PUT: {
            next(action);
            const { sourceID, dpSourceObj, authToken } = action.payload;

            API.updateDPSource(sourceID, dpSourceObj, authToken.idToken)
                .then(res => {
                    const log = {
                        object_id: sourceID,
                        object_type: "kyc_source_edit",
                        user: authToken.account.name
                    };
                    store.dispatch({
                        type: activityLoggerActionTypes.LOG_CHANGE,
                        payload: {log, authToken}
                    });
                    store.dispatch(closeAddEditModal("DP Source"));
                    store.dispatch(updatedDPSourceRefresh());
                    store.dispatch(setRouterLink(MARVEL.VERITAS.data_sources + "kyc/" + sourceID))
                })
                .catch(error => {
                    const errorObject = error.response.data
                    const message = [];
                    // Only handle custom error of duplicate identifier number.
                    if (errorObject.message) {
                        const messageList = errorObject.message.split(".")
                        messageList.forEach(m => message.push(m));
                        message.pop()
                        store.dispatch(displayDuplicateMessage(message, true));
                    } else {
                        // pretty print the error message for the user
                        // eslint-disable-next-line no-unused-vars
                        for (let [key, value] of Object.entries(errorObject)) {
                            message.push(toUpperCaseSentence(value[0]));
                        }
                        store.dispatch(displayErrorMessage(message, true));
                    }
                });
            break;
        }

        case apiActionsDPSource.PUT_KYB: {
            next(action);
            const { sourceID, dpSourceObj, authToken } = action.payload;

            API.updateKYBDPSource(sourceID, dpSourceObj, authToken.idToken)
                .then(res => {
                    const log = {
                        object_id: sourceID,
                        object_type: "kyb_source_edit",
                        user: authToken.account.name
                    };
                    store.dispatch({
                        type: activityLoggerActionTypes.LOG_CHANGE,
                        payload: {log, authToken}
                    });
                    store.dispatch(closeAddEditModal("DP Source"));
                    store.dispatch(updatedDPSourceRefresh());
                    store.dispatch(setRouterLink(MARVEL.VERITAS.data_sources + "kyb/" + sourceID))
                })
                .catch(error => {
                    const errorObject = error.response.data
                    const message = [];
                    // Only handle custom error of duplicate identifier number.
                    if (errorObject.message) {
                        const messageList = errorObject.message.split(".")
                        messageList.forEach(m => message.push(m));
                        message.pop()
                        store.dispatch(displayDuplicateMessage(message, true));
                    } else {
                        // pretty print the error message for the user
                        // eslint-disable-next-line no-unused-vars
                        for (let [key, value] of Object.entries(errorObject)) {
                            message.push(toUpperCaseSentence(value[0]));
                        }
                        store.dispatch(displayErrorMessage(message, true));
                    }
                });
            break;
        }

        case apiActionsDPSource.GET: {
            next(action);
            const { sourceID, authToken } = action.payload;
            API.getDPSourceByID(sourceID, authToken.idToken)
                .then(res => {
                    store.dispatch(fetchSourceDetailSuccess(res.data, INPUT_FIELDS));
                }).catch(error => {
                    console.error(error);
                    throw error;
                });

            break;
        }

        case apiActionsDPSource.GET_KYB: {
            next(action);
            const { sourceID, authToken } = action.payload;
            API.getKYBSourceByID(sourceID, authToken.idToken)
                .then(res => {
                    store.dispatch(fetchSourceDetailSuccess(res.data, INPUT_FIELDS));
                }).catch(error => {
                    console.error(error);
                    throw error;
                });

            break;
        }

        case apiActionsDPSource.DELETE_KYC_SOURCE: {
            next(action);

            const {sourceID, authToken} = action.payload;
            API.deleteDPSource(sourceID, authToken.idToken)
                .then(res => {
                    const log = {
                        object_id: sourceID,
                        object_type: "kyc_data_source_delete",
                        user: authToken.account.name
                    };
                    store.dispatch({
                        type: activityLoggerActionTypes.LOG_CHANGE,
                        payload: {log, authToken}
                    });
                    store.dispatch(toggleSourceDeleteWarning());
                    // it is expected that the user will get to the source detail page
                    // from a service detail page, hence a goBack is instructed where
                    // the user can see service detail and all the sources associated with it.
                    store.dispatch(setRouterLink(-1))
                })
                .catch(error => console.error(error));

            break;
        }

        case apiActionsDPSource.DELETE_KYB_SOURCE: {
            next(action);

            const {sourceID, authToken} = action.payload;
            API.deleteKYBDPSource(sourceID, authToken.idToken)
                .then(res => {
                    const log = {
                        object_id: sourceID,
                        object_type: "kyb_data_source_delete",
                        user: authToken.account.name
                    };
                    store.dispatch({
                        type: activityLoggerActionTypes.LOG_CHANGE,
                        payload: {log, authToken}
                    });
                    store.dispatch(toggleSourceDeleteWarning());
                    // it is expected that the user will get to the source detail page
                    // from a service detail page, hence a goBack is instructed where
                    // the user can see service detail and all the sources associated with it.
                    store.dispatch(setRouterLink(-1))

                })
                .catch(error => console.error(error));

            break;
        }

        default: next(action);
    }
}

export default apiMiddlewareDPSources;
